import "./ErrorModal.css";
import "bootstrap/dist/css/bootstrap.min.css";

import React from "react";
import { Button, Modal } from "react-bootstrap";
import ErrorIcon from "../../assets/imgs/error-icon.svg";
import DefaultButton from "../DefaultButton/DefaultButton";

const ErrorModal = ({
  title,
  description,
  confirmTitle,
  backTitle,
  onConfirm,
  onBack,
  onExit,
  show,
}) => (
  <Modal show={show} onHide={onExit}>
    <div className="confirmation-modal">
      <div className="confirmation-modal__icon">
        <img src={ErrorIcon} alt="Forbidden Icon" />
      </div>
      <div className="error-modal__title">
        <h4>{title}</h4>
      </div>
      <div className="error-modal__description">
        <p>{description}</p>
      </div>
      <div className="error-modal__actions">
        {confirmTitle && (
          <div className="error-modal__button">
            <DefaultButton
              title={confirmTitle}
              onClick={onConfirm}
            />
          </div>
        )}
        {backTitle && (
          <div className="error-modal__button">
            <DefaultButton
              title={backTitle}
              onClick={onBack}
              type="secondary"
            />
          </div>
        )}
      </div>
    </div>
  </Modal>
);

ErrorModal.defaultProps = {
  title: "Erro",
  description: "Erro ao executar operação!",
  onConfirm: () => { },
  onBack: () => { },
  onExit: () => { },
  show: false,
}

export default ErrorModal;
